import { createContext } from 'react';
import { IContainerContext } from './IContainerContext';

export const ContainerContext = createContext<IContainerContext>({} as IContainerContext);
